import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import {
  WorkDay,
  StateService,
  ToolService,
  RouterService,
  AbsenceEntry,
} from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-absence-detail',
  templateUrl: './absence-detail.component.html',
  styleUrls: ['./absence-detail.component.scss'],
  standalone: false,
})
export class AbsenceDetailComponent implements OnInit {
  paramId: string;
  absenceEntry: AbsenceEntry;
  absenceDays: string;
  sub: Subscription;
  isTodayOrInFuture: boolean;

  constructor(
    public state: StateService,
    public route: ActivatedRoute,
    public tools: ToolService,
    public modalCtrl: ModalController,
    public routerService: RouterService
  ) {}

  ngOnInit() {
    this.sub = this.state.absenceEntries$.subscribe((x) => {
      this.absenceEntry = x.find((x) => x.id == this.paramId);
      if (this.absenceEntry != null) {
        let now = new Date().toISOString();

        this.isTodayOrInFuture =
          this.tools.dateStringsAreSameDay(this.absenceEntry.date, now) ||
          this.absenceEntry.date > now;

        /*this.absenceDays = this.tools.getWorkdaysBetween(
          this.absenceEntry.timeEntry.start,
          this.absenceEntry.timeEntry.end
        );*/
      }
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  editWorkDay() {
    this.modalCtrl.dismiss('edit', 'confirm');
  }

  async deleteAbsenceEntry() {
    await this.state.deleteAbsenceEntry(this.absenceEntry.id);
    await this.modalCtrl.dismiss('delete', 'confirm');
  }

  approveEntry() {
    this.state.approveAbsenceEntry(this.paramId);
    this.modalCtrl.dismiss('approved', 'confirm');
  }

  rejectEntry() {
    this.state.rejectAbsenceEntry(this.paramId, 'Abgelehnt!');
    this.modalCtrl.dismiss('rejected', 'confirm');
  }
}
